import { Box, Text } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import ProductsMasterView from './ProductsMasterView';

export default function MastersSection() {
	const location = useLocation();
	const isProducts = location.pathname.includes('/masters/products');

	if (isProducts) {
		return <ProductsMasterView />;
	}

	return (
		<Box pt={{ base: '120px', md: '75px' }} px={{ base: '20px', md: '30px' }}>
			<Text color="secondaryGray.600" fontSize="md">
				Módulo en preparación.
			</Text>
		</Box>
	);
}
